// 报销申请列表
<template>
  <div class="threeLevelMain">
      <!-- 查询区域 -->
      <div class="queryBox clearfix">
          <div class="query_row">
              <!-- <div class="scan_box">
                  <span class="sp_scan">发票类型：</span>
                  <el-select v-model="queryFormList.type" placeholder="全部" class="ip_scan" size="mini">
                    <el-option label="专票" value="1"></el-option>
                    <el-option label="普票" value="2"></el-option>
                    <el-option label="形式发票" value="3"></el-option>
                  </el-select>
              </div> -->
              
              <!-- 按钮区域 -->
              <!-- <div class="btn_box">
                <el-button 
                type="primary" 
                size="mini" 
                style="margin-left:20px;"
                @click="searchBtn">查询</el-button>

                <el-button 
                type="primary" 
                size="mini" 
                style="margin-left:20px;"
                @click="resetSearch">重置</el-button>
              </div> -->
          </div>
      </div>

      <!-- 内容区域 -->
      <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
      :totalCount="totalCount"
      v-loading="loading"
      >
       
        
        <el-table-column
            slot="department"
            width="100"
            label="部门"
            align="center"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.department == 1">人事部</div>
                <div v-else-if="scope.row.department == 2">财务部</div>
                <div v-else-if="scope.row.department == 3">市场部</div>
                <div v-else-if="scope.row.department == 4">运营部</div>
                <div v-else-if="scope.row.department == 5">招商部</div>
                <div v-else-if="scope.row.department == 6">总经办</div>
                <div v-else-if="scope.row.department == 7">技术部</div>
            </template>
        </el-table-column>
        <el-table-column
            slot="state"
            width="150"
            label="状态"
            align="center"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.state == ''" class="fontColor_theme">等待上级审核</div>
                <div v-else-if="scope.row.state == 0" class="fontColor_danger">未通过</div>
                <div v-else-if="scope.row.state == 1" class="fontColor_warning">等待财务主管审核</div>
                <div v-else-if="scope.row.state == 2" class="fontColor_success">通过</div>
                <div v-else-if="scope.row.state == 3" style="color:#660099;">等待怒发审核</div>
            </template>
        </el-table-column>
       
    
        <el-table-column
            slot="revise_handle"
            width="90"
            label="修改信息"
            align="center"
            fixed="right"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.user_id == userId ? true : false">
                    <el-button 
                    type="primary" 
                    size="mini" plain 
                    @click="openDialog(scope.row)"
                    >修改</el-button>
                </div>
            </template>
        </el-table-column>
        <el-table-column
            slot="review_handle"
            width="150"
            label="审核操作"
            align="center"
            fixed="right"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.user_id == userId ? false : true">
                    <el-button type="success" size="mini" plain @click="reviewReimbur(scope.row,'3','通过')">通过</el-button>
                    <el-button type="danger" size="mini" plain @click="reviewReimbur(scope.row,'0','驳回')">驳回</el-button>
                </div>
            </template>
        </el-table-column>
        
      </tablePageComp>
      
      <!-- 弹窗 -->
      <el-dialog
    title="发票信息修改"
    :visible.sync="dialogVisible"
    width="40%"
    :before-close="dialogClose"
    >
        <!-- 如果不是市场部或财务部，展示修改按钮 -->
        <Reimbursement :reviseFormData="reviseFormData" className="formItems2"></Reimbursement>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/api'
import utils from '@/libs/utils.js'
import Reimbursement from '@/components/workOrder/reimbursementApply.vue'
export default {
components:{
    Reimbursement,
},
data() {
    let userId = utils.sessionGetStore('user_id')
    let userName = utils.sessionGetStore('user_name')
    
    return {
        userId:userId,
        userName:userName,
        // 列表查询条件
        queryFormList:{},
        // 表格内容相关
        loading: false,
        dataList:[],
        isCriteriaQuery: false,
        updateDataTag: false,
        totalCount:0,// 数据总条数
        columnsList:[
            {
                label: '类别',
                prop: 'type',
                width: 100
            },
            {
                label: '具体事项',
                prop: 'test'
            },
            {
                label: '金额',
                prop: 'money',
                width:110
            },
            {
                label: '状态',
                slotName: 'state'
            },
            {
                label: '部门',
                slotName: 'department'
            },
            {
                label: '提交人',
                prop: 'user_name',
                width:100
            },
            {
                label: '审核人',
                prop: 'up_id',
                width:100
            },
            {
                label: '创建时间',
                prop: 'add_time',
                width:150
            },
            {
                label: '修改信息',
                slotName: 'revise_handle'
            },
            {
                label: '审核操作',
                slotName: 'review_handle'
            },

        ],

        // 弹窗相关
        dialogVisible: false,
        // 传递给子组件的现有表单信息
        reviseFormData:'',

        // 审核相关
        smallSign:true,// 报销提交人是否是当前登录人 是---开启修改，关闭审核 否---反之
    }
},
mounted(){

},

methods:{
// 查询部分
  //带条件查询，查询按钮事件
  searchBtn(){
    // 将查询条件存入本地
    utils.sessionSetStore('reimburSearch',this.queryFormList)
      
    // 是否带条件查询---更新
    this.isCriteriaQuery = true
    // 主动更新数据标记---更新，子组件调用获取数据方法
    this.updateDataTag = !this.updateDataTag

  },
  
  //重置查询
  resetSearch(){
      this.queryFormList = {
            // type:'', // 发票类型
            // state:'',// 是否为提前开票
            // money_state:'',// 金额筛选start
            // money_end:'',// 筛选 end
            // buy_invoice_title:'',// 购买方发票抬头
        },

    // 清除本地查询条件
    utils.sessionRemoveStore('reimburSearch')

    // 是否带条件查询---更新
    this.isCriteriaQuery = false
    // 主动更新数据标记---更新，子组件调用获取数据方法
    this.updateDataTag = !this.updateDataTag
  },

  //表格数据获取
  dataQueryFunc(){
      //查询条件
    //   let paramObj = this.queryFormList
    let paramObj = {
        id:this.userId
    }

      //判断是否是默认查询
      if(this.isCriteriaQuery){
          
      }
        
      //传递给表格组件，在表格组件中取数据，进行其他操作
    return {
        apiName:'getReimbursementList',
        paramObj:paramObj,
        success: function (response, callBack) {
            // console.log(response)
            let records = response.data.data.list
            let arr = []
            for (let i = 0; i < records.length; i++) {
                let obj = records[i]
                //全部表头 和接口返回字段一一对应
                let standardObj = {
                    // "corporate_name": "公司名称",
                    type:'类别',
                    test:'内容',
                    money:'金额',
                    state:'状态',
                    department:'部门',
                    user_id:'提交人',
                    up_id:'审核人',
                }
                for (let key in standardObj) {
                  if (obj[key] == null || obj[key] == undefined) {
                      obj[key] = ''
                  }
                }

                
                arr.push(obj)

            }
            // console.log(records)
            // 数据列表---更新
            this.dataList = arr
            // console.log('工单列表',this.dataList)
            // 数据总条数---更新
            this.totalCount = response.data.data.totalCount//接口返回的数据总条数

            // 回调函数
            if (callBack) {
                callBack()
            }
        }.bind(this),
        failed: function (error, callBack) {
            // 回调函数
            if (callBack) {
                callBack()
            }
        }
    }
  },

//  弹窗---修改信息
openDialog(data){
    if(data.up_id != ''){
        // 如果工单已被审核，则不能修改
        this.$message({
            type: 'warning',
            message: '已开始审核，无法进行修改操作！'
        })
        return
    }

    this.dialogVisible = true
    
    this.reviseFormData = data
},

// 审核按钮
reviewReimbur(data,state,type){
    let paramObj = {
        up_id: this.userId,// 
        state: state,
        id: data.id
    }

    switch(this.userId){
        case '1':
            // 怒发
            paramObj.state = 1
            if(data.state != 3){
                // 如果状态不是待怒发审核---3，就禁止
                this.$message({
                    type: 'warning',
                    message: '已审核完毕，无法再次操作！'
                })
                return
            }
            break;
        case '4':
        case '15':
            // 财务
            paramObj.state = 2
            if(data.state != 2 && data.state != ''){
                // 如果状态不是待财务审核---1，就禁止此次审核
                // 如果是财务部门提的工单，他的上级也需要审核，所以当state = ''时，也可以审核
                this.$message({
                    type: 'warning',
                    message: '已审核完毕，无法再次操作！'
                })
                return
            }
            break;
        default:
            // 如果不是财务或怒发，则如果状态不是 待上级审核--'', 就禁止
            if(data.state != ''){
                    this.$message({
                    type: 'warning',
                    message: '已审核完毕，无法再次操作！'
                })
                return
            }
    }

    // 确认弹窗
    this.$confirm(`确认 ${type} 此申请吗，是否继续？`,'提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        api.reviseReimbursement(paramObj)
        .then(res => {
            // console.log(res)
            utils.notificationInfo('提示',"审批完毕","success")
            this.updateDataTag = !this.updateDataTag
        })
        .catch(error => {
            console.log(error)
            utils.notificationInfo('提示',"审批完毕","success")
        })
    })
    .catch(() => {
        this.$message({
            type: 'info',
            message: '已取消操作'
        });          
    });

},

// 确认提交信息----财务或市场部提交
submitForm(formName){
    this.$refs[formName].validate((valid) => {
        if(valid) {
            let paramObj = this.ruleForm
            api.reviseInvoiceList(paramObj)
            .then(res => {
                // console.log(res)
                this.updateDataTag = !this.updateDataTag
                this.dialogVisible = false
                utils.notificationInfo('提示','提交成功','success')
            })
            .catch(error => {
                console.log(error)
                utils.notificationInfo('提示','提交失败','error')
            })
        } else {
            utils.notificationInfo('提示','填写信息有误','error')
            return false;
        }
    })
},
dialogClose(done) {
    this.$confirm('确认关闭？')
        .then(_ => {
        done();
        })
        .catch(_ => {});
},

},
}
</script>

<style>

</style>